import CityPageTemplate from "../city-template/CityPageTemplate";
import { carrolltonTXConfig } from "./data";

export default function CarrolltonTXPage() {
  return <CityPageTemplate config={carrolltonTXConfig} />;
}